import { render } from "./VTour.vue?vue&type=template&id=14c12eeb"
import script from "./VTour.vue?vue&type=script&lang=js"
export * from "./VTour.vue?vue&type=script&lang=js"

import "./VTour.vue?vue&type=style&index=0&id=14c12eeb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__